import React from 'react';
import { pick } from 'ramda';

import { BackboneReplacer } from '@core/js/backbone/components/BackboneReplacer';
import { Link } from '@core/js/components/common/Link';
import { Balance } from '@core/js/components/main/Balance';

import { SvgIcon } from '@interlayer/js/custom/components/common/SvgIcon';

import { useTranslations } from '@core/js/hooks/i18n';
import { useUserSelector } from '@core/js/store/hooks';

import { useDynamicTags } from '@interlayer/js/custom/hooks/useDynamicTags';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/custom/utils/constants';

import style from './Header.scss';

// this file full sun override
export const Header = () => {
    const translate = useTranslations('playtech.mobile.system.component.myAccountSidebar.');
    const { userName, userDetails: { firstName, lastName } } = useUserSelector(pick(['userName', 'userDetails']));
    const [dTagGreenGambling, dTagBonusHistory] = useDynamicTags([
        DYNAMIC_TAG_NAMES.GREEN_GAMBLING,
        DYNAMIC_TAG_NAMES.BONUS_HISTORY
    ]);

    return (
        <div className={style.container}>
            <div className={style.fullName}>
                {firstName}

                {' '}

                {lastName}
            </div>

            <div className={style.userName}>
                {userName}
            </div>

            <BackboneReplacer dynamicName="HEADER_DEPOSIT_BUTTON" viewName="headerdepositbutton" />

            <div className={style.balance}>
                {translate('cashBalance')}

                <Balance type="real_gaming_balance" />
            </div>

            <div className={style.balance}>
                {translate('bonusBalance')}

                <Balance type="bonus_balance" />
            </div>

            <div className={style.balance}>
                {translate('bonusPendingWinnings')}

                <Balance type="bonus_pending_winnings" />
            </div>

            <div className={style.balance}>
                {translate('totalBalance')}

                <Balance type="balance_calc" args="casino_gaming_balance" />
            </div>

            {dTagBonusHistory && (
                <Link className={style.bonusHistory} href={dTagBonusHistory}>
                    {translate('bonusHistory')}
                </Link>
            )}

            {dTagGreenGambling && (
                <Link className={style.greenGaming} href={dTagGreenGambling}>
                    <SvgIcon
                        className={style.greenGamingIcon}
                        type={translate('greenGaming.icon')}
                    />

                    {translate('greenGaming')}
                </Link>
            )}

            <div className={style.divider} />
        </div>
    );
};
